<template>
  <div class="home-news">
    <Heading class="home-news__title" :level="3">Destaques</Heading>
    <OverviewInbox
      data-testid="home-news"
      @removeNews="trackRemove"
      @viewNews="trackView"
    >
      <template #empty-message>
        <p class="home-news__empty-message text-p-5">
          <span class="title">Você já leu todos os destaques! 👏</span>
          <br />
          Fique atento para mais notícias e promoções selecionadas especialmente
          para você.
        </p>
      </template>
    </OverviewInbox>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { Heading } from '@warrenbrasil/nebraska-web';
import { IFeedItem } from '@/modules/home/services/news';
import { trackNewsClick, trackNewsRemoveClick } from './track-events';
import OverviewInbox from '../OverviewInbox/OverviewInbox.vue';

@Component({
  components: {
    Heading,
    OverviewInbox
  }
})
export default class HomeNews extends Vue {
  trackView(news: IFeedItem) {
    trackNewsClick(news.dashboardTitle, news.code);
  }

  trackRemove(news: IFeedItem) {
    trackNewsRemoveClick(news.dashboardTitle, news.code);
  }
}
</script>

<style lang="less" scoped>
.home-news {
  .container-width(0, @size-spacing-x1800);

  &__title {
    margin-bottom: @size-spacing-x400;
  }

  &__empty-message {
    color: @text-secondary;
  }
}

@media @mobile {
  .home-news {
    &__empty-message > .title {
      display: inline-block;
      margin-bottom: @size-spacing-x300;
    }
  }
}
</style>
